import classNames from 'classnames/bind';

import { Breadcrumb, Grid, Layout, theme } from 'antd';
import { Content, Footer } from 'antd/es/layout/layout';
import { Outlet, useLocation } from 'react-router-dom';
import HeaderLayout from '~/components/header/Header';
import SideBar from '~/components/sidebar/SideBar';
import styles from './AdminPanel.module.scss';
import packageJson from '../../../package.json';
import { useTranslation } from 'react-i18next';
const cx = classNames.bind(styles);

const AdminPanel = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const isMobile = !screens.md;
  const currentYear = new Date().getFullYear();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const breadCrumbView = () => {
    const { pathname } = location;
    const pathnames = pathname
      .split('/')
      .filter((item) => item)
      .slice(1);
    const pathnamesObj = pathnames.map((item) => {
      return { title: t(`bread_crumb_${item}`) };
    });
    return <Breadcrumb items={pathnamesObj} />;
  };

  return (
    <Layout className={cx('adminLayout_container')}>
      <SideBar />
      <Layout className={cx('adminLayout_info')}>
        <HeaderLayout />
        <Content className={cx('adminLayout_content')}>
          <div
            style={{ background: colorBgContainer }}
            className={cx('adminLayout_content_detail')}
          >
            {isMobile && <div className={cx('adminLayout_bread_crumb')}>{breadCrumbView()}</div>}
            <Outlet />
          </div>
        </Content>
        <Footer className={cx('adminFooter')}>
          <div>&copy; {currentYear} FIFE. All rights reserved.</div>
          <div className={cx('version')}>{`Version ${packageJson.version}`}</div>
        </Footer>
      </Layout>
    </Layout>
  );
};

export default AdminPanel;
